import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "bulma/css/bulma.css";
import Home from "./components/home";
import Header from "./components/reading";
import Game from "./components/Game";
import End from "./components/Not in use for internal testing/end";
import AfterTask from "./components/afterTask";
import Quiz from "./components/quiz";
import Post_survey from "./components/post_survey";
import Login from "./Login"
// import Policy from "./components/policy";
import App from "./App";


import "./App.css";

export var HANDLE_STOP;

const routing = (
  <Router>
    <Switch>
      {/* <Route path="/" component={Welcome}  /> */}

      <Route path="/" component={App} exact={true} />
      <Route path="/home" component={Home} />
      <Route path="/login" component={Login} />
      <Route path="/game" component={Game} />
      {/* <Route path="/lesson" component={lesson} />
      <Route path="/typing" component={typing} /> */}
      <Route path="/reading" component={Header} />
      <Route path="/quiz" component={Quiz} />
      <Route path="/after-task" component={AfterTask} />
      <Route path="/end" component={End} />
      <Route path="/post_survey" component={Post_survey} />
      
      {/* <Route path="/policy" component={Policy} /> */}
      {/* <Route path="/video1" component={Video1} />
      <Route path="/video2" component={Video2} />
      <Route path="/typing1" component={Typing1} />
      <Route path="/lessonQuestions" component={LessonQuestions} /> */}
    </Switch>
  </Router>
);
ReactDOM.render(routing, document.getElementById("root"));
